import { render, staticRenderFns } from "./ChuyouRemenLuxian.vue?vue&type=template&id=4d4edb94&scoped=true&"
import script from "./ChuyouRemenLuxian.vue?vue&type=script&lang=js&"
export * from "./ChuyouRemenLuxian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4edb94",
  null
  
)

export default component.exports